import React from 'react';
import { Box, Card, FlexBox, MuiBox, MuiTable, SvgIcon, Tooltip, Typography } from '@kis-technologies/kis-ui';
import { useStyles } from '../styled';
import { MediaTypes, LinkedContentTableProps } from '../types';
import { getMediaTypeLabel } from '../utils';

const LinkedContentTable = (props: LinkedContentTableProps) => {
  const { linkedContentUrl, onDeleteClick, onEditClick } = props;

  const classes = useStyles({ genreTab: false })();

  const mediaLabel = getMediaTypeLabel(MediaTypes.LINKED_CONTENT);

  return (
    <FlexBox fullWidth noWrap>
      <Box>
        <MuiBox className={classes.tableDetailsOuterBox}>
          <Card hasBorderRadius raised fullHeight>
            <Box flexOverride="1">
              <MuiTable.TableContainer className={classes.singleRowTableContainer}>
                <MuiTable.Table stickyHeader>
                  <MuiTable.TableHead>
                    <MuiTable.TableRow className={classes.tableRow}>
                      <MuiTable.TableCell
                        className={`${classes.tableCell} ${classes.tableHeadCell} ${classes.tableFileNameCell}`}
                      >
                        Content URL
                      </MuiTable.TableCell>
                      <MuiTable.TableCell
                        className={`${classes.tableCell} ${classes.tableHeadCell} ${classes.linkedContentTableActionsCell}`}
                      >
                        Actions
                      </MuiTable.TableCell>
                    </MuiTable.TableRow>
                  </MuiTable.TableHead>
                  <MuiTable.TableBody>
                    {linkedContentUrl && (
                      <MuiTable.TableRow className={classes.tableRow}>
                        <MuiTable.TableCell className={`${classes.tableCell} ${classes.tableFileNameCell}`}>
                          {linkedContentUrl && (
                            <Typography fontSize={16} sx={{ wordBreak: 'break-all' }}>
                              {linkedContentUrl}
                            </Typography>
                          )}
                        </MuiTable.TableCell>
                        <MuiTable.TableCell className={`${classes.tableCell} ${classes.linkedContentTableActionsCell}`}>
                          {linkedContentUrl && (
                            <FlexBox justifyContent="end" gap="10px">
                              <Tooltip title={`Edit ${mediaLabel}`}>
                                <FlexBox className={classes.actionSvgIconBox} data-action="edit" onClick={onEditClick}>
                                  <SvgIcon name="edit_circle" size={36} />
                                </FlexBox>
                              </Tooltip>
                              <Tooltip title={`Delete ${mediaLabel}`}>
                                <FlexBox
                                  className={classes.actionSvgIconBox}
                                  data-action="delete"
                                  onClick={onDeleteClick}
                                >
                                  <SvgIcon name="exit_circle" size={36} />
                                </FlexBox>
                              </Tooltip>
                            </FlexBox>
                          )}
                        </MuiTable.TableCell>
                      </MuiTable.TableRow>
                    )}
                  </MuiTable.TableBody>
                </MuiTable.Table>
              </MuiTable.TableContainer>
            </Box>
          </Card>
        </MuiBox>
      </Box>
    </FlexBox>
  );
};

export default LinkedContentTable;
